
import {  Star, Truck, Clock } from 'lucide-react';
import { Category } from '@cabukaka/types';
import HeroSection from '../../ui/HeroSection';

interface HeroProps {
    category: Category,
}
export default function Hero({ category }: HeroProps) {
    return (
        <HeroSection title={category.name} more={
            <div className="flex flex-wrap gap-3">
                {[
                    { icon: Truck, label: 'Livraison rapide' },
                    { icon: Star, label: 'Qualité garantie' },
                    { icon: Clock, label: '24h/24 · 7j/7' },
                ].map(({ icon: Icon, label }) => (
                    <div
                        key={label}
                        className="flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 text-white text-sm font-medium"
                    >
                        <Icon className="w-4 h-4 text-orange-200" />
                        {label}
                    </div>
                ))}
            </div>
        } />
    )
}
